module.exports = __webpack_public_path__ + "img/calendar.1efef601.svg";